module.exports = __webpack_public_path__ + "static/img/workPsico.11764186.webp";